import React, { useState } from "react";

import { ROUTES } from "./Route";
import Login from "../Account/Login";
import SpecialitiesManegementScreen from "./SpecialitiesManegement";

export default function SpecialitiesManegement() {
  const [page, setPage] = useState(ROUTES.TRANING_MANAGEMENT);

  switch (page) {
    case ROUTES.TRANING_MANAGEMENT:
      return <SpecialitiesManegementScreen setPage={setPage} />;
    default:
      return <Login />;
  }
}
